import { useEventListener } from '@vueuse/core';
import { tippy } from 'vue-tippy';
import { useDeviceSize } from '@/js/composables/useDeviceSize';

const { isMobileOrTablet } = useDeviceSize();

if (isMobileOrTablet.value) {
    const links = document.querySelectorAll<HTMLAnchorElement>('.tippy-author');

    links.forEach((link) => {
        useEventListener(link, 'click', (event) => {
            event.preventDefault();
        });
    });
}

tippy('.tippy-author', {
    content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);

        if (!template) {
            return null;
        }

        const clonedTemplate = template.cloneNode(true) as HTMLElement;

        clonedTemplate.style.display = 'block';

        return clonedTemplate;
    },
    theme: 'tip-info',
    placement: 'bottom',
    interactive: true,
    trigger: isMobileOrTablet.value ? 'click' : 'mouseenter focus',
});
